import React, { useRef, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

function RegionTab({ tabs, tabContents, tabButtons }) {
  const parentRef = useRef(null);
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);

  // Create a unique key based on the current route
  const storageKey = `activeTab-${location.pathname}`;

  // Retrieve the activeTab from sessionStorage or default to 0
  const [activeTab, setActiveTab] = useState(() => {
    const savedActiveTab = sessionStorage.getItem(storageKey);
    return savedActiveTab !== null ? Number(savedActiveTab) : 0;
  });

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    centerActiveTab();
  }, [activeTab]);

  useEffect(() => {
    if (activeTab >= tabs.length) {
      setActiveTab(0);
      sessionStorage.setItem(storageKey, "0");
    }
  }, [tabs.length, activeTab, storageKey]);

  const handleTabClick = (index) => {
    setActiveTab(index);
    sessionStorage.setItem(storageKey, index);
  };

  const centerActiveTab = () => {
    if (!parentRef.current) return;
    const parentWidth = parentRef.current.offsetWidth;
    const tabWidth = parentRef.current.childNodes[0]?.offsetWidth || 0;
    const activeTabOffset = activeTab * tabWidth;
    const centerPosition = activeTabOffset - parentWidth / 2 + tabWidth / 2;

    if (parentRef.current) {
      parentRef.current.scrollLeft = centerPosition;
    }
  };

  return (
    <div ref={parentRef} style={{ marginBottom: "15px", position: "relative" }}>
      <div
        className="d-inline-flex border-bottom border-1 border-solid border-gray-300 w-100 overflow-auto p-2"
        style={{ whiteSpace: "nowrap" }}
      >
        <div className="me-5">
          {tabs.map((tab, index) => (
            <button
              key={index}
              type="button"
              style={{
                backgroundColor: "transparent",
                border: "none",
                borderBottom: `2px solid ${
                  index === activeTab ? "#29457c" : "transparent"
                }`,
                color: index === activeTab ? "#29457c" : "rgba(0, 0, 0, 0.65)",
                cursor: "pointer",
                fontSize: "14px",
                padding: "10px 16px 8px 16px",
                marginRight: index === tabs.length - 1 ? 0 : "10px",
                position: "relative",
                transition: "border-bottom 0.3s ease",
              }}
              onClick={() => handleTabClick(index)}
            >
              {tab.title}
            </button>
          ))}
        </div>
        <div className="ms-auto mt-1">{tabButtons}</div>
      </div>

      <div style={{ marginTop: "20px" }}>{tabContents[activeTab]}</div>
    </div>
  );
}

export default RegionTab;
